{
  "alert.informative": "Информативный",
  "alert.negative": "Негативно",
  "alert.notice": "Уведомление",
  "alert.positive": "Позитивно",
  "attachmentlist.nextAttachments": "Показать следующие вложения",
  "attachmentlist.previousAttachments": "Показать предыдущие вложения",
  "chat.newMessage": "Новое сообщение",
  "chat.scrollToBottom": "Прокрутить вниз",
  "messagefeedback.thumbDown": "Плохой ответ",
  "messagefeedback.thumbUp": "Хороший ответ",
  "promptfield.aiDisclaimer": "Ответы генерируются с помощью ИИ и могут быть неточными. Выполните проверку перед использованием.",
  "promptfield.aiUserGuidlines": "Правила использования ИИ",
  "promptfield.attachments": "Вложения",
  "promptfield.insertButton": "Добавить",
  "promptfield.label": "Запрос",
  "promptfield.placeholder": "Готовы начать работу? Задайте вопрос, поделитесь идеей или добавьте задачу.",
  "promptfield.placeholder.small": "Задать любой вопрос",
  "promptfield.stopButton": "Остановить",
  "promptfield.submitButton": "Отправить",
  "promptfield.uploading": "Загрузка",
  "responsestatus.loading": "Загрузка",
  "responsestatus.processing": "Обработка...",
  "voicebutton.startListening": "Начать запись",
  "voicebutton.stopListening": "Остановить запись"
}
